export function setParentToShare(state, data) {
  state.parentToShare = data
}

export function cleanErrors(state) {
  state.error = false
  state.errorMessage = ''
}

export function error(state, error) {
  console.log("errorcatch", error)
  state.error = true
  state.errorMessage = error
}